import React from 'react'
import { Row, Col, Typography, Divider } from 'antd'
import { FacebookOutlined, InstagramOutlined, TwitterOutlined, YoutubeOutlined } from '@ant-design/icons'

const { Title } = Typography

function Icon({ name }) {
  switch(name){
    case 'instagram':
      return <InstagramOutlined />
    case 'twitter':
      return <TwitterOutlined />
    case 'youtube':
      return <YoutubeOutlined />
    default:
      return <FacebookOutlined />
  }
}

function SocialIcon({ name, color, url }) {
  return (
    <a href={url} target="_blank">
      <div className="socialicon" style={{backgroundColor: color}} >
        <Icon name={name} />
      </div>
    </a>
  )
}

export default function Terms() {
  return (
    <div className="termsc">
      <header>
        <img src={process.env.PUBLIC_URL + '/logo.svg'} style={{ height: "200px", width:"200px" }} />
        <Title level={5}>UROLOGÍA INTEGRAL AVANZADA</Title>
        <Title level={2}>POLÍTICA DE PRIVACIDAD</Title>
      </header>
      <Row justify="center">
        <Col xs={24} sm={24} md={20} lg={18} xl={16}>
          <Divider />
          <div id="content">
            <p>
              Esta app es propiedad del Dr. Gabriel Iván Farrera Santillán y está operado por IDT Solutions. Estos Términos establecen los términos y condiciones bajo los cuales tu puedes usar nuestra app y servicios ofrecidos por nosotros. Esta app ofrece a los usuarios información relevante sobre temas de Urología. Al acceder o usar nuestra app, usted aprueba que haya leído, entendido y aceptado estar sujeto a estos Términos:
            </p>
            <p>
              Para usar nuestro app y / o recibir nuestros servicios, debes tener al menos 16 años de edad, o la mayoría de edad legal en tu jurisdicción, y poseer la autoridad legal, el derecho y la libertad para participar en estos Términos como un acuerdo vinculante. No tienes permitido utilizar esta app y / o recibir servicios si hacerlo está prohibido en tu país o en virtud de cualquier ley o regulación aplicable a tu caso.
            </p>
            <p>
              Para usar nuestro app y / o recibir nuestros servicios, debes proporcionar un correo electrónico así como un número de telefono los cuales serán utilizado como medios de contacto entre paciente y el departamento de administración médico. Nunca compartiremos tus datos con terceros.
            </p>
            <p>
              Podemos, sin aviso previo, cambiar los servicios; dejar de proporcionar los servicios o cualquier característica de los servicios que ofrecemos; o crear límites para los servicios. Podemos  suspender de manera permanente o temporal el acceso a los servicios sin previo aviso ni responsabilidad por cualquier motivo, o sin ningún motivo.
            </p>
            <p>
              El Servicio y todos los materiales incluidos o transferidos, incluyendo, sin limitación, software, imágenes, texto, gráficos, logotipos, patentes, marcas registradas, marcas de servicio, derechos de autor, fotografías, audio, videos, música y todos los Derechos de Propiedad Intelectual relacionados con ellos, son la propiedad exclusiva del Dr. Gabriel Iván Farrera Santillán. Salvo que se indique explícitamente en este documento, no se considerará que nada en estos Términos crea una licencia en o bajo ninguno de dichos Derechos de Propiedad Intelectual, y tu aceptas no vender, licenciar, alquilar, modificar, distribuir, copiar, reproducir, transmitir, exhibir públicamente, realizar públicamente, publicar, adaptar, editar o crear trabajos derivados de los mismos.
            </p>
            <p>
              Podemos terminar o suspender de manera permanente o temporal tu acceso al servicio sin previo aviso y responsabilidad por cualquier razón, incluso si a nuestra sola determinación tu violas alguna disposición de estos Términos o cualquier ley o regulación aplicable. Puedes descontinuar el uso y solicitar cancelar tu cuenta y / o cualquier servicio en cualquier momento.
            </p>
            <p>
              Usted acuerda indemnizar y eximir de responsabilidad al Dr. Gabriel Iván Farrera Santillán de cualquier demanda, pérdida, responsabilidad, reclamación o gasto (incluidos los honorarios de abogados) que terceros realicen en tu contra como consecuencia de, o derivado de, o en relación con tu uso de la app o cualquiera de los servicios ofrecidos en la app.
            </p>
            <p>
              En la máxima medida permitida por la ley aplicable, en ningún caso el Dr. Gabriel Iván Farrera Santillán será responsable por daños indirectos, punitivos, incidentales, especiales, consecuentes o ejemplares, incluidos, entre otros, daños por pérdida de beneficios, buena voluntad, uso, datos. u otras pérdidas intangibles, que surjan de o estén relacionadas con el uso o la imposibilidad de utilizar el servicio. 
            </p>
            <p>
              En la máxima medida permitida por la ley aplicable, el Dr. Gabriel Iván Farrera Santillán no asume responsabilidad alguna por (i) errores, errores o inexactitudes de contenido; (ii) lesiones personales o daños a la propiedad, de cualquier naturaleza que sean, como resultado de tu acceso o uso de nuestro servicio; y (iii) cualquier acceso no autorizado o uso de nuestros servidores seguros y / o toda la información personal almacenada en los mismos.
            </p>
            <p>
              Acepta recibir de vez en cuando nuestros mensajes y materiales de promoción, por correo postal, correo electrónico o cualquier otro formulario de contacto que nos proporciones (incluido tu número de teléfono para llamadas o mensajes de texto). Si no deseas recibir dichos materiales o avisos de promociones, simplemente avísanos en cualquier momento.
            </p>
            <p>
              Nos reservamos el derecho de modificar estos términos de vez en cuando a nuestra entera discreción. Por lo tanto, debes revisar estas páginas periódicamente. Cuando cambiemos los Términos de una manera material, te notificaremos que se han realizado cambios importantes en los Términos. El uso continuado de la app o nuestro servicio después de dicho cambio constituye tu aceptación de los nuevos Términos. Si no aceptas alguno de estos términos o cualquier versión futura de los Términos, no uses o  accedas (o continúes accediendo) a la app o al servicio.
            </p>
            <p>
              Estos Términos, los derechos y recursos provistos aquí, y todos y cada uno de los reclamos y disputas relacionados con este y / o los servicios, se regirán, interpretarán y aplicarán en todos los aspectos única y exclusivamente de conformidad con las leyes sustantivas internas de México, sin respeto a sus principios de conflicto de leyes. Todos los reclamos y disputas se presentarán y usted acepta que sean decididos exclusivamente por un tribunal de jurisdicción competente.
            </p>
          </div>
          <Divider />
        </Col>
      </Row>
      <footer>
        <div id="social">
          <SocialIcon name="facebook" color="#1877f2" />
          <SocialIcon name="twitter" color="#1da1f2" />
          <SocialIcon name="youtube" color="#ff0000" />
          <SocialIcon name="instagram" color="#c32aa3" />
        </div>
        <span>
          2025 - © Urología Integral Avanzada
        </span>
      </footer>
    </div>
  )
}
